import { fb, validators } from "form";

export function getStoreEditModel(data) {
  const model = fb.group({
    storeCode: [data.storeCode || "", [validators.Required()], { type: "text" }],
    orgStoreCode: [data.storeCode || "", [], { type: "hidden" }],
    //storeStatus: [data.storeStatus, [validators.Required()], { type: 'select', options: statusList }],
    //country: [data.country || '', [validators.Required()], { type: 'text' }],
    storeName: [data.storeName || "", [validators.Required()], { type: "text" }],
    storeUrl: [data.storeUrl || "", [validators.Required()], { type: "text" }],
    buyOnline: [data.buyOnline, [], { label: "Buy Online", type: "checkbox" }],
    seq: [data.seq || "0", [], { type: "number", helpText: "Will automatically re-numbered" }],

    iconPath: [data.iconPath || "", [], { type: "text" }],
    mailchimpName: [data.mailchimpName || "", [], { type: "text", helpText: "For matching field with MailChimp. Check the code first in MailChimp" }],
  });

  return model;
}
